import { ODataSelect } from "@iconics/core";
import { BuiltInType } from '@iconics/providers.fadx-platform-api-client-v2';

export class Attribute extends ODataSelect
{
    public Id = '';
    public Name = '';
    public BuiltInType: BuiltInType | '' = '';
    public IsArray: boolean | null = null;
    public IsMandatory: boolean | null = null;
}
